import { createFileRoute } from "@tanstack/react-router"

import { newsroomHead } from "./-components/newsroom"
import { NewsroomPage } from "./-components/NewsroomPage"
import { PodcastGrid } from "./-components/PodcastGrid"
import { loadNewsroomContent } from "./-data/content"

export const Route = createFileRoute("/_content/news/podcasts")({
  loader: () => loadNewsroomContent("podcasts"),
  staleTime: Infinity,
  preloadStaleTime: Infinity,
  head: () => newsroomHead("podcasts"),
  component: PodcastsPage,
})

function PodcastsPage() {
  const episodes = Route.useLoaderData()

  return (
    <NewsroomPage category="podcasts">
      <PodcastGrid episodes={episodes} />
    </NewsroomPage>
  )
}
